import React from 'react';
import cn from 'classnames';
import i18next from 'i18next';
import { connect } from 'react-redux';
import Dropdown from '../Dropdown/Dropdown';
import InputText from '../InputText/InputText';
import ExchangeResult from '../Crypto/CryptoCalc/ExchangeResult/ExchangeResult';
import Api from '../../api';
import Cancellable from '../Cancellable/Cancellable';
import { normalizeNum } from '../../utils';
import Button from '../Button/Button';
import PendingButton from '../Button/PendingButton';
import apiForm from './apiForm';
import FormErrors from './FormErrors';

const MAX_AMOUNT = 1000000;

class WithdrawFormCrypto extends Cancellable {
  constructor(props) {
    super(props);

    this.state = {
      coins: [],
    };
  }

  componentDidMount() {
    this.fetchCoins();
  }

  fetchCoins = () => {
    return this.request(Api.coins()).then((response) => {
      this.setState({ coins: response.data || [] });
    });
  };

  handleCoinSelectChange = ({ value }) => {
    this.props.onInputChange('selectedCoin', value, this.calc);
  };

  handleValueChange = (event) => {
    this.props.onInputChange('value', event, this.calc);
  };

  handleSetAllAmount = () => {
    this.props.onInputChange('value', this.props.balance, this.calc);
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.beforeSubmit();

    this.request(
      Api.withdrawCrypto(this.props.serializeForm(e.currentTarget))
    ).then((response) => {
      this.props.afterSubmit(response);
    });
  };

  calc = () => {
    const {
      formState: { values },
    } = this.props;

    const { coins } = this.state;

    const value = +values.value;
    const { price } = coins.find((c) => c.id === values.selectedCoin) || {};
    const { usdrex } = coins.find((c) => c.id === values.selectedCoin) || {};

    let newAmount = values.amount;
    let newValue = values.value;
    let newUsd = values.usd;

    if (Number.isNaN(value) || !price || !usdrex) {
      newAmount = 0;
       newUsd = 0;
    } else {
      if (value > MAX_AMOUNT) {
        newValue = MAX_AMOUNT;
        newAmount = normalizeNum(MAX_AMOUNT / price, 6);
        newUsd = Math.max(0, Math.floor(newValue / usdrex));
      } else {
        newAmount = Math.max(0, normalizeNum(value / price, 6));
        newUsd = Math.max(0, Math.floor(value / usdrex));
      }
    }
    this.props.onInputChange('amount', newAmount);
    this.props.onInputChange('usd', newUsd);
    this.props.onInputChange('value', newValue);
  };

  render() {
    const { coins } = this.state;
    const {
      onInputChange,
      formState: { pending, errors, invalid, submitted, values },
    } = this.props;

    const blockSubmit =
      !values.password ||
      !values.amount ||
      !values.usd ||
      !values.value ||
      !values.selectedCoin ||
      !values.address;

    return (
      <div className="form withdraw-form-crypto">
        <form onSubmit={this.onSubmit}>
          {(!submitted || errors.length !== 0) && (
            <React.Fragment>
              <span className="form__title form__title--center form__title--secondary">
                {i18next.t('withdraw_crypto.title')}
              </span>

              <Dropdown
                placeholder={i18next.t('withdraw_crypto.coin_select')}
                className="withdraw-form-crypto__select"
                value={values.selectedCoin}
                onChange={this.handleCoinSelectChange}
                options={coins.map((coin) => ({
                  value: coin.id,
                  label: coin.name,
                }))}
              />

              <InputText
                placeholder={i18next.t('withdraw_crypto.address')}
                view="rectangle"
                autoComplete="off"
                className={cn('withdraw-form-crypto__address', {
                  invalid: invalid.includes('address'),
                })}
                onChange={onInputChange.bind(null, 'address')}
                value={values.address}
              />

              <div className="withdraw-form-crypto__row">
                <InputText
                  placeholder={i18next.t('withdraw_crypto.amount')}
                  view="rectangle"
                  autoComplete="off"
                  className="withdraw-form-crypto__amount"
                  onChange={this.handleValueChange}
                  value={values.value}
                />

                <Button
                  tagName="button"
                  type="button"
                  className="withdraw-form-crypto__all"
                  view="default"
                  defaultStyles={true}
                  onClick={this.handleSetAllAmount}
                >
                  {i18next.t('withdraw_crypto.all')}
                </Button>
              </div>

              <InputText
                placeholder={i18next.t('withdraw_crypto.password')}
                view="rectangle"
                type="password"
                autoComplete="password"
                className={cn('withdraw-form-crypto__password', {
                  invalid: invalid.includes('password'),
                })}
                onChange={onInputChange.bind(null, 'password')}
                value={values.password}
              />

              <ExchangeResult
                className="withdraw-form-crypto__result"
                amount={values.amount}
                usd={values.usd}
                currency={values.selectedCoin}
                format={false}
              />

              <FormErrors errors={errors} />
            </React.Fragment>
          )}

          {submitted && errors.length === 0 && (
            <React.Fragment>
              <span className="form__title form__title--center">
                {i18next.t('withdraw_crypto.success')}
              </span>
              <p
                className="withdraw-form-crypto__success-text"
                dangerouslySetInnerHTML={{
                  __html: i18next.t('withdraw_crypto.success_text'),
                }}
              />
            </React.Fragment>
          )}

          <PendingButton
            tagName="button"
            className="form__submit withdraw-form-crypto__submit"
            disabled={blockSubmit}
            pending={pending}
            done={submitted && errors.length === 0}
          >
            {i18next.t('withdraw_crypto.action')}
          </PendingButton>

          <p
            className="withdraw-form-crypto__note"
            dangerouslySetInnerHTML={{
              __html: i18next.t('withdraw_crypto.success_text'),
            }}
          />
        </form>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    wallets: state.user.wallets,
    balance: state.user.balance,
  };
})(
  apiForm(WithdrawFormCrypto, {
    values: {
      address: '',
      amount: 0,
      value: '',
      selectedCoin: null,
    },
  })
);



// WEBPACK FOOTER //
// ./app/components/Form/WithdrawFormCrypto.jsx